<section class="petitions-page">

  <!-- HERO -->
  <div class="petitions-hero">
    <div class="petitions-eyebrow">Get Out The Vote</div>
    <h1>Sign the Pledge</h1>
    <p>As the Libertarian Party nominee, Lydia is automatically on the ballot - now the fight is turnout. Pledge to vote and help us reach <strong>12,000 to 15,000 doors</strong> across Michigan before Election Day. Add your name today.</p>
  </div>

  <!-- BODY -->
  <div class="petitions-body">
    <div class="container">
      <div class="petitions-grid">

        <!-- FORM -->
        <div class="petitions-form-wrap">

          <div *ngIf="!petitionSubmitted">
            <h2>Add Your Name</h2>
            <form #petitionForm="ngForm" (ngSubmit)="onPetitionSubmit()" id="petition-form">

              <div class="form-group">
                <label for="petition-name">Full Name</label>
                <input
                  id="petition-name"
                  type="text"
                  placeholder="Your full name"
                  required
                  [(ngModel)]="petition.name"
                  name="name"
                  #name="ngModel"
                  aria-required="true"
                  [disabled]="isSubmitting"
                />
                <div *ngIf="name.invalid && name.touched" class="error">Full name is required.</div>
              </div>

              <div class="form-group">
                <label for="petition-email">Email Address</label>
                <input
                  id="petition-email"
                  type="email"
                  placeholder="your@email.com"
                  required
                  [(ngModel)]="petition.email"
                  name="email"
                  #email="ngModel"
                  aria-required="true"
                  pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                  [disabled]="isSubmitting"
                />
                <div *ngIf="email.invalid && email.touched" class="error">
                  <span *ngIf="email.errors?.['required']">Email is required.</span>
                  <span *ngIf="email.errors?.['pattern']">Please enter a valid email address.</span>
                </div>
              </div>

              <div class="form-group">
                <label for="petition-zip">Michigan Zip Code</label>
                <input
                  id="petition-zip"
                  type="text"
                  placeholder="49938"
                  required
                  [(ngModel)]="petition.zip"
                  name="zip"
                  #zip="ngModel"
                  aria-required="true"
                  pattern="\d{5}"
                  [disabled]="isSubmitting"
                />
                <div *ngIf="zip.invalid && zip.touched" class="error">
                  <span *ngIf="zip.errors?.['required']">Zip code is required.</span>
                  <span *ngIf="zip.errors?.['pattern']">Please enter a valid 5-digit zip code.</span>
                </div>
              </div>

              <button
                type="submit"
                [disabled]="petitionForm.invalid || isSubmitting"
              >
                {{ isSubmitting ? 'Submitting...' : 'Sign the Pledge' }}
              </button>

              <div *ngIf="errorMessage" class="error submit-error">{{ errorMessage }}</div>

              <p class="form-note">Your information is kept private and used only for campaign outreach purposes.</p>
            </form>
          </div>

          <div *ngIf="petitionSubmitted" class="success-message">
            <div class="success-icon">✓</div>
            <h3>Pledge Recorded!</h3>
            <p>Thank you for supporting Lydia's campaign. Your name brings us one step closer to winning in November.</p>
            <button type="button" (click)="resetPetitionForm()">Sign Again</button>
          </div>

        </div>

        <!-- SIDEBAR -->
        <aside class="petitions-sidebar">

          <div class="progress-card">
            <div class="progress-card__label">Doors Knocked</div>
            <div class="progress-card__count">{{ signatures | number }}<span> / {{ goal | number }}</span></div>
            <div class="progress-track">
              <div class="progress-fill" [style.width.%]="progressPct"></div>
            </div>
            <div class="progress-card__pct">{{ progressPct }}% of goal &mdash; push to Election Day, November 3, 2026</div>
          </div>

          <div class="why-card">
            <h4>Why pledge?</h4>
            <p>As the Libertarian Party nominee, Lydia's ballot access is automatic. What decides this race now is turnout - every door knocked and every voter reached.</p>
            <a routerLink="/volunteer">Canvass your county →</a>
          </div>

          <div class="info-card">
            <div class="info-card__icon">📋</div>
            <div>
              <div class="info-card__label">Eligibility</div>
              <div class="info-card__value">Registered Michigan voter</div>
            </div>
          </div>

          <div class="info-card">
            <div class="info-card__icon">⏰</div>
            <div>
              <div class="info-card__label">Election Day</div>
              <div class="info-card__value">November 3, 2026</div>
            </div>
          </div>

        </aside>

      </div>
    </div>
  </div>

</section>
